import React from "react"

import OptimizedImage from "../../../utils/OptimizedImage"

import Background from "./components/Background"
import { GridContainer } from "./styles/DynamicImageGrid.styled"

const DynamicImageGrid = ({ component }) => {
  const { dynamicImages } = component

  return (
    <GridContainer>
      <div className="background">
        <Background />
      </div>
      {dynamicImages &&
        dynamicImages?.map((image, index) => (
          <OptimizedImage
            key={`image-${index}`}
            className={`image img-${index}`}
            image={image?.gatsbyImageData}
            alt={image?.alt}
          />
        ))}
    </GridContainer>
  )
}

export default DynamicImageGrid
